import { InvoicesActions } from "../../types";

const initialState: any = { loading: false, data: [] };

function prepareItem(items: Array<any>) {
  return items.map((item: any) => {
    const total_price = item.qty * item.unit_price;
    return {
      ...item,
      unit_price: item.unit_price?.toFixed(2),
      qty: item.qty === 0 ? "" : item.qty,
      total_price: total_price === 0 ? "" : total_price,
    };
  });
}

export default function (state: any = initialState, action: any) {
  switch (action.type) {
    case InvoicesActions.StoreInitialState:
      return { ...state, data: prepareItem(action.payload.invoiceItems) };

    case `${InvoicesActions.ItemCreate}Success`:
    case `${InvoicesActions.ItemUpdate}Success`:
    case `${InvoicesActions.ItemDestroy}Success`:
    case `${InvoicesActions.ItemDestroyAll}Success`:
      return { ...state, data: prepareItem(action.result) };

    default:
      return state;
  }
}
